// Sidebar navigation prefs. Same shape as condtionsViewPrefs.js: string "1"/"0" values,
// every localStorage touch wrapped so a blocked/full storage never throws into the UI.

export const NAV_PINNED_KEY = "nav.sidebar.pinned"
export const NAV_SIDEBAR_FLAG_KEY = "nav.sidebar.enabled"

// ── Feature flag ─────────────────────────────────────────────────────────────
// Default OFF. Turn on per-build with VUE_APP_SIDEBAR_NAV=1, or per-browser (for testing
// without a rebuild) with localStorage.setItem("nav.sidebar.enabled", "1").
// The localStorage value wins when present so a tester can also force it OFF on a build
// that has it on.
export function isSidebarNavEnabled() {
  try {
    const override = window?.localStorage?.getItem(NAV_SIDEBAR_FLAG_KEY)
    if (override === "1") return true
    if (override === "0") return false
  } catch (e) {}
  return process.env.VUE_APP_SIDEBAR_NAV === "1"
}

// ── Pinned ───────────────────────────────────────────────────────────────────
export function readNavPinned() {
  try {
    return window?.localStorage?.getItem(NAV_PINNED_KEY) === "1"
  } catch (e) {
    return false
  }
}

export function writeNavPinned(val) {
  try {
    window?.localStorage?.setItem(NAV_PINNED_KEY, val ? "1" : "0")
  } catch (e) {}
}

// Cross-tab sync: pin in one tab, the others follow.
export function subscribeNavPinned(cb) {
  const handler = e => {
    if (e?.key !== NAV_PINNED_KEY) return
    cb(e?.newValue === "1")
  }
  window?.addEventListener?.("storage", handler)
  return () => window?.removeEventListener?.("storage", handler)
}
